import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Almoxarifado/Home/Content";

const Almoxarifado = () => {
    return (
        <>
            <NavBar
                title="ALMOXARIFADO"
                navTo="/modules"
            />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    );
};

export default Almoxarifado;
